import React from "react";

import Trash from "../../../../assets/trash.svg";
import styled from "styled-components";

const CartItem = styled.div`
   {
    width: 98%;
    height: 100px;
    border: 1px solid #eeee;
    margin: 0 0 10px 0;
    border-radius: 5px;
  }
`;

const ItemLeft = styled.div`
   {
    width: 87%;
    height: 100%;
    float: left;
  }
`;
const ItemRight = styled.div`
   {
    width: 13%;
    height: 100%;
    float: right;
  }
`;
const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-top: 35px;
  cursor: pointer;
`;
const ImageContainer = styled.div`
  width: 28%;
  height: 100%;
  float: left;
`;
const Image = styled.img`
  width: 85%;
  height: 78%;
  margin: 10% 1%;
  object-fit: cover;
  border-radius: 5px;
`;
const ItemDetails = styled.div`
  width: 68%;
  height: 100%;
  float: right;
  text-align: left;
`;
const ItemTitle = styled.h2`
  padding: 7px 0 5px 0;
  margin: 0;
  font-size: 1em;
  font-weight: 500;
`;
const DecButton = styled.button`
  border: 1px solid #eee;
  padding: 2px 0;
  width: 32px;
  font-size: 20px;
  cursor: pointer;
  background: none;
  margin: 5px 10px 0 0;
`;
const IncButton = styled.button`
  width: 32px;
  border: 1px solid #eee;
  padding: 2px 10px;
  font-size: 20px;
  cursor: pointer;
  background: none;
  margin: 5px 10px;
`;
const ItemPrice = styled.p`
  padding: 0;
  margin: 0;
`;

const cartItem = (props) => {
  return (
    <CartItem>
      <ItemLeft>
        <ImageContainer>
          <Image src={props.cartItem.image} alt="img" />
        </ImageContainer>
        <ItemDetails>
          <ItemTitle>{props.cartItem.name} </ItemTitle>
          <ItemPrice>
            {props.cartItem.price} * {props.cartItem.quantity} ={" "}
            {props.cartItem.price * props.cartItem.quantity}
          </ItemPrice>

          {/* <DecButton onClick={()=>{props.cartItemQntDcrHandler(props.id)}}>-</DecButton> */}
          {/* <DecButton onClick={()=>{props.cartItemQntDcrHandler(props.id)}}>-</DecButton>
          <span>{props.cartItem.quantity}</span> */}

          {/* <IncButton onClick={()=>{props.cartItemQntIncHandler(props.id)}}>+</IncButton> */}
        </ItemDetails>
      </ItemLeft>
      <ItemRight>
        {/* <DeleteIcon onClick={()=>{props.removeCartItemHandler(props.id)}} src={Trash} alt="icon" /> */}
        {/* <DeleteIcon src={Trash} alt="icon" /> */}
      </ItemRight>
    </CartItem>
  );
};

export default cartItem;
